export const messages = {
  en: {
    groupBuySetting: {
      title: 'Group Buy Settings',
      searchConditions: 'Search Conditions',
      settingInfo: 'Setting Information',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      confirmDelete: 'Confirm Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
      reset: 'Reset',
      search: 'Search',
      groupBuyName: 'Group Buy Name',
      groupBuyDesc: 'Group Buy Description',
      validHours: 'Valid Hours',
      startTime: 'Start Time',
      endTime: 'End Time',
      settingId: 'Setting ID',
      operation: 'Operation',
      addTitle: 'Add Group Buy Setting',
      editTitle: 'Edit Group Buy Setting',
      deleteTitle: 'Delete Confirmation',
      deleteContent: 'Are you sure to delete this group buy setting?',
      success: {
        add: 'Add success',
        edit: 'Edit success',
        delete: 'Delete success'
      },
      rules: {
        required: 'This field is required',
        maxLength: 'Cannot exceed {max} characters',
        number: 'Must be a valid number'
      }
    }
  },
  zh: {
    groupBuySetting: {
      title: '拼团设置管理',
      searchConditions: '查询条件',
      settingInfo: '设置信息',
      add: '添加',
      edit: '修改',
      delete: '删除',
      confirmDelete: '确认删除',
      cancel: '取消',
      confirm: '确定',
      reset: '重置',
      search: '查询',
      groupBuyName: '拼团名称',
      groupBuyDesc: '拼团简介',
      validHours: '拼团时效',
      startTime: '开始时间',
      endTime: '结束时间',
      settingId: '设置ID',
      operation: '操作',
      addTitle: '添加拼团设置',
      editTitle: '修改拼团设置',
      deleteTitle: '删除确认',
      deleteContent: '确定删除该拼团设置吗？',
      success: {
        add: '添加成功',
        edit: '修改成功',
        delete: '删除成功'
      },
      rules: {
        required: '此项为必填项',
        maxLength: '不能超过{max}个字符',
        number: '必须为有效数字'
      }
    }
  }
}